var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTransport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    stroke: "#1957E8",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.4999 12.834H12.4166C13.4249 12.834 14.2499 12.009 14.2499 11.0007V1.83398H5.99994C4.62494 1.83398 3.42411 2.59481 2.80078 3.71314",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M2.33301 15.584C2.33301 17.1057 3.56134 18.334 5.08301 18.334H5.99967C5.99967 17.3257 6.82467 16.5007 7.83301 16.5007C8.84134 16.5007 9.66634 17.3257 9.66634 18.334H13.333C13.333 17.3257 14.158 16.5007 15.1663 16.5007C16.1747 16.5007 16.9997 17.3257 16.9997 18.334H17.9163C19.438 18.334 20.6663 17.1057 20.6663 15.584V12.834H17.9163C17.4122 12.834 16.9997 12.4215 16.9997 11.9173V9.16732C16.9997 8.66315 17.4122 8.25065 17.9163 8.25065H19.0988L17.5314 5.50983C17.2014 4.94149 16.5964 4.58398 15.9364 4.58398H14.2497V11.0007C14.2497 12.009 13.4247 12.834 12.4163 12.834H11.4997",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M7.83333 20.1667C8.84586 20.1667 9.66667 19.3459 9.66667 18.3333C9.66667 17.3208 8.84586 16.5 7.83333 16.5C6.82081 16.5 6 17.3208 6 18.3333C6 19.3459 6.82081 20.1667 7.83333 20.1667Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M15.1663 20.1667C16.1789 20.1667 16.9997 19.3459 16.9997 18.3333C16.9997 17.3208 16.1789 16.5 15.1663 16.5C14.1538 16.5 13.333 17.3208 13.333 18.3333C13.333 19.3459 14.1538 20.1667 15.1663 20.1667Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M20.6667 11V12.8333H17.9167C17.4125 12.8333 17 12.4208 17 11.9167V9.16667C17 8.6625 17.4125 8.25 17.9167 8.25H19.0991L20.6667 11Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M2.33301 7.33398H7.83301",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M2.33301 10.084H5.99967",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M2.33301 12.834H4.16634",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransport);
export default __webpack_public_path__ + "static/media/transport.0e88a6977a0589b01531aaf9c7a6aa1d.svg";
export { ForwardRef as ReactComponent };